import { ISingleOrderWithDetailsModel } from '@/shared/models/orders/single-order-with-details.model';
import BarChart from '@/statistics/components/BarChart';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FC, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetChartNumbers } from '@/statistics/templates/shared/useGetChartNumbers';

export interface ICampaignMetaBarCharts {
  order: ISingleOrderWithDetailsModel;
}

const CampaignMetaBarCharts: FC<ICampaignMetaBarCharts> = ({ order }): JSX.Element => {
  const { t } = useTranslation();

  const { totalClicks, totalImpressions, impressionsData, clicksData, impressionsLabels, clicksLabels } =
    useGetChartNumbers(order);

  return (
    <div>
      <Card sx={{ width: '100%' }}>
        <Grid item xs={12} p={2}>
          <Divider>
            <Typography variant="h4">{t('campaignSummary')}</Typography>
          </Divider>
        </Grid>
        <CardContent>
          <Grid container display={'flex'} justifyContent={'space-around'}>
            <Grid item xs={12} md={5}>
              <Box textAlign={'center'}>
                <Typography variant="h5">
                  {t('clicks')} {totalClicks}
                </Typography>
                <BarChart
                  chartType="single"
                  labels={clicksLabels}
                  dataSets={[
                    {
                      label: t('clicks'),
                      data: clicksData,
                    },
                  ]}
                  order={order}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={5}>
              <Box textAlign={'center'}>
                <Typography variant="h5">
                  {t('impressions')} {totalImpressions}
                </Typography>
                <BarChart
                  chartType="single"
                  labels={impressionsLabels}
                  dataSets={[
                    {
                      label: t('impressions'),
                      data: impressionsData,
                    },
                  ]}
                  order={order}
                />
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};

export default CampaignMetaBarCharts;
